<template>
  <section class="app-main">
    <router-view v-slot="{ Component, route }">
      <transition mode="out-in">
        <keep-alive :include="cachedViews" :max="10">
          <component :is="Component" :key="route.name || route.path"/>
        </keep-alive>
      </transition>
    </router-view>
  </section>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  setup() {
    const store = useStore()
    const cachedViews = computed(() => store.state.tagViews.cachedViews)

    return {
      cachedViews
    }
  }
})
</script>

<style lang="scss" scoped>
.app-main {
  /* 45= navbar  45  */
  height: calc(100vh - 45px);
  width: 100%;
  position: relative;
  overflow: auto;
  background-color: var(--surface-main, #ffffff);
  border-left: 8px solid var(--stage-gutter, #f5f5f5);
  box-sizing: border-box;
}

.fixed-header+.app-main {
  padding-top: 45px;
  height: 100vh;
  overflow: auto;
}

.hasTagsView {
  .app-main {
    /* TagsView is inside Navbar now, so it's just 45px total */
    height: calc(100vh - 45px);
    border-left: 8px solid var(--stage-gutter, #f5f5f5);
  }

  .fixed-header+.app-main {
    padding-top: 45px;
  }
}
</style>
